import dayjs from 'dayjs';

const DATE_TIME_FORMAT = 'YYYY-MM-DD HH:mm:ss';
const DATE_FORMAT = 'YYYY-MM-DD';

type DateInput = string | number | Date | null | undefined;

const format = (value: DateInput, pattern: string, fallback: string) => {
  if (value === null || value === undefined || value === '') return fallback;
  const d = dayjs(value);
  // 解析失败时原样返回，避免把无法识别的内容显示成 Invalid Date
  return d.isValid() ? d.format(pattern) : String(value);
};

/**
 * 格式化为 YYYY-MM-DD HH:mm:ss
 * 后端 datetime 序列化为 ISO 格式（2026-07-21T11:19:43），展示时统一去掉 T
 */
export const formatDateTime = (value: DateInput, fallback = '-') =>
  format(value, DATE_TIME_FORMAT, fallback);

/** 格式化为 YYYY-MM-DD */
export const formatDate = (value: DateInput, fallback = '-') =>
  format(value, DATE_FORMAT, fallback);

/**
 * 签署截止日期展示：后端只存日期，实际截止时间为当天 23:59:59，前端固定补全时分秒
 */
export const formatDeadline = (value: DateInput, fallback = '-') => {
  const date = formatDate(value, '');
  return date ? `${date} 23:59:59` : fallback;
};
